import type { ReactNode } from 'react';
import Button from '@mui/material/Button';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { StatusPage } from './StatusPage';

/** 403. Reached from a route guard, so it must not itself require a permission. */
export function ForbiddenPage(): ReactNode {
  const { t } = useTranslation('shell');
  return (
    <StatusPage
      icon={<LockOutlinedIcon fontSize="large" />}
      title={t('forbidden.title')}
      description={t('forbidden.description')}
      action={
        <Button component={Link} to="/" variant="contained">
          {t('forbidden.backHome')}
        </Button>
      }
    />
  );
}
